import React, { Component } from 'react';
import { Header, Nav } from './../../common';
import './Home.css';

class Home extends Component {
	componentDidMount() {}

	componentWillUnmount() {}

	_loading() {
		return null;
	}

	render() {
		return (
			<div className="Home">
				<Header />
				<div className="container">
					<Nav />
				</div>
				{this._loading()}
			</div>
		);
	}
}

export { Home };



// WEBPACK FOOTER //
// ./src/components/screens/home/Home.js